import type { EventTypes } from '@racemap/sdk/schema/events';
import classnames from 'classnames';
import type { JSX } from 'react';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { AnimatedChevronIcon } from '../../BasicComponents/Icons';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import type { ItemStyle } from './types';

export type EventsHeaderProps = {
  style: ItemStyle;
  isOpen: boolean;
  eventType: EventTypes;
  onToggle: () => void;
};

export function EventsHeader({
  style,
  isOpen,
  eventType,
  onToggle,
}: EventsHeaderProps): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        <AnimatedChevronIcon isOpen={isOpen} />
        &nbsp;
        <div className="starter-list-header-item-label">{t(`list.${eventType}`)}</div>
      </div>
    </div>
  );
}
